import React, { useState, useEffect, Fragment, useRef } from 'react';
import propTypes from 'prop-types';
import { VIEWS } from './AiExperience.jsx';
import { LoadingScreen } from '_ui-core-js/React/components/LoadingScreen.jsx';
import { Modal } from '_ui-core-js/React/components/Modal.jsx';
import { AlertTextContent } from '_ui-core-js/React/components/AlertTextContent.jsx';
import { getArtworkPredictionId, getArtworkStatus } from '../../store/actions/artwork.js';
import warning from '../../resources/images/warning.svg';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities//fireGTMTrackingEvent.js';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';

export function ArtworkGenerationScreen(props) {

  const { data, state, user } = props;
  const { errorModal } = data;
  const { assetRootPath } = state.settings; 
  const [artworkGenerated, setArtworkGenerated] = useState(false);
  const [retryArtworkGeneration, setRetryArtworkGeneration] = useState(false);
  const loadingStatusRef = useRef()

  const [loadingStage, setLoadingStage] = useState(data['loading-text'][0]);

  function proceedToArtworkPresentation() {
    state.setActiveView(VIEWS.artworkPresentation.name);
  };

  function createAIEnginePayload() {
    const atmosphere = state.atmosphere;
    const payload = {
      colorPalette: state.colorPalettePayload,
      atmosphere: atmosphere.toLowerCase(),
      vehicleColour: state.selectedCarColorCode,
      locale: user.locale
    };

    state.selectedUserChoicesImages.forEach(obj => {
      payload[obj.data.key] = obj.data.value;
    });

    return payload;
  };

  async function fetchArtwork(payload, state,  count = 0) {
    try {
      setLoadingStage(loadingStatusRef.current[count])
      const {url, id, status, error} = await getArtworkStatus(payload)

      if (status === 'succeeded') {
        state.setArtworkUrl(url);
        state.setArtworkId(id)
        setArtworkGenerated(true);
      } else if (status === 'failed') {
          const isNSFW = _.includes(error, 'NSFW');
          if (isNSFW) {
            setRetryArtworkGeneration(isNSFW)
          } else {
            throw new Error('Art Generation Failed')
          } 
        } 
        else {
            setTimeout(() =>  fetchArtwork(payload, state, count+1), 3000)
        }
    } catch (error) {
      throw(error)
    }
  }

  function errorModalOnClickCallback() {
    state.setError(false);
    state.setActiveView(VIEWS.carColorSelection.name);
  };

  useEffect(async () => {
    try {
      const payload = createAIEnginePayload();
      const {predictionId} = await getArtworkPredictionId(payload)
      await fetchArtwork({...payload, predictionId}, state);
    } catch (error) {
        state.setError(true);
    }
  }, [retryArtworkGeneration]);

  useEffect(() => {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.workflowEvent,
      componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience, 
      componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      action: CORE_GTM_TRACKING_VALUES.action.workflowStep,
      label: CORE_GTM_TRACKING_VALUES.label.artworkGenerationLoadingScreen
    }, {
      workflow: {
        name: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience,
        step: CORE_GTM_TRACKING_VALUES.label.artworkGenerationLoadingScreen,
        conversion: 0,
        variant: (state.loggedIn && state.instagramCode) ? 'instagram' : 'not-connected'
      }
    });

    loadingStatusRef.current = [...data['loading-text'], ...data['loading-text'], ...data['loading-text']];
  }, []);


  return (
    <Fragment>
      <LoadingScreen 
      text={loadingStage}
      videoUrl={data.videoUrl} 
      loopVideo={true} 
      onLoadingCompletionCallback={proceedToArtworkPresentation}
      loadingConditionsComplete={artworkGenerated}
      backgroundCover={false}
      />
      <Modal
      id='lbx-ai-art-generation-error'
      showCloseButton={false}
      showModalTrigger={state.error}
      >
        <AlertTextContent
        imgUrl={`${assetRootPath}/assets/images/warning.svg`} 
        heading={errorModal.heading}
        subheading={errorModal.subheading}
        body={errorModal.body}
        buttonLabel={errorModal.buttonLabel}
        onClickCallback={errorModalOnClickCallback}
        />
      </Modal>
    </Fragment>
  )
};

ArtworkGenerationScreen.propTypes = {
  block: propTypes.string.isRequired,
  state: propTypes.object.isRequired,
  data: propTypes.object.isRequired
};

